/*
 * Copyright (c) 2021 - 2026 All rights reserved by Ferenc Farkas <wolferi93@gmail.com>
 */

/**
 * @file useChatHubBadge.js
 * @description
 * Combined unread badge of the messenger hub (team chat + live support) used by
 * EVERY chat entry point (management TopBar, POS CustomHeader, Functions menu,
 * Service tab/More menu, Warehouse tile, Management "Data" hub).
 *
 * Visibility deliberately stays the Team Chat gate the entry points already
 * used (`visible` = build flag on + store/role entitled) — only the COUNT grows
 * to include the live-support unread messages.
 */

import {useTeamChat} from './TeamChatContext';
import {useSupportUnread} from './supportUnreadStore';
import {combinedUnread} from './chatHub';

/**
 * Hook: combined hub badge.
 * @returns {{visible: boolean, total: number, mention: boolean, teamUnread: number, supportUnread: number}}
 */
export const useChatHubBadge = () => {
    const {visible, unreadTotal, mentionTotal} = useTeamChat();
    const {count: supportUnread} = useSupportUnread({enabled: !!visible});

    return {
        visible: !!visible,
        total: combinedUnread(unreadTotal, supportUnread),
        mention: (Number(mentionTotal) || 0) > 0,
        teamUnread: Number(unreadTotal) || 0,
        supportUnread,
    };
};

export default useChatHubBadge;
